<app-user-form
  [user]="user"
  [modal]="true"
  (closeModal)="ref.close($event)"
  (userCreated)="userCreated($event)"
/>
